import { Component, Input, OnInit } from "@angular/core";
import { PreviusStudiesDigitizedService } from "src/app/services/previous-studies-digitized/previous-studies-digitized.service";

@Component({
  selector: "app-previus-studies-links-control",
  templateUrl: "./previus-studies-links-control.component.html",
  styleUrls: ["./previus-studies-links-control.component.css"],
})
export class PreviusStudiesLinksControlComponent implements OnInit {
  links: string[] = [];
  @Input() appointmentId: number;

  constructor(
    private previusStudiesDigitizedService: PreviusStudiesDigitizedService
  ) {}

  ngOnInit(): void {
    this.previusStudiesDigitizedService
      .getPreviousStudiesLinksByMedicalAppointmentId(this.appointmentId)
      .then((x) => (this.links = x));
  }
}
